<template>
  <div class="view pa24">
    <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'selectProductCategory') }}</p>
    <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="auto">
      <el-form-item :label="$t('merchandise', 'productCategory')" prop="productsTypeId">
        <el-select
          v-model="ruleForm.productsTypeId"
          :placeholder="$t('merchandise', 'pleaseSelect')"
          clearable
        >
          <el-option
            v-for="(item, index) in options"
            :key="index"
            :label="item.productsTypeName"
            :value="item.productsTypeId"
          >
            {{ item.productsTypeName }}
          </el-option>
        </el-select>
        <el-button class="ml10" type="primary" @click="addGoodsType">{{ $t('merchandise', 'addNewCategory') }}</el-button>
      </el-form-item>
      <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'inputProductBasicInfo') }}</p>
      <el-form-item :label="$t('merchandise', 'productTitle')" prop="productsName">
        <el-input
          type="text"
          :placeholder="$t('merchandise', 'pleaseEnterContent')"
          style="width: 330px"
          v-model="ruleForm.productsName"
          maxlength="30"
          show-word-limit
        />
      </el-form-item>
      <el-form-item :label="$t('merchandise', 'productPrice')" prop="specificPrice">
        <el-radio v-model="radio" label="1">
          {{ $t('merchandise', 'specificAmount') }}
          <el-input
            style="width: 100px"
            type="number"
            :disabled="radio !== '1'"
            v-model="ruleForm.specificPrice"
            :placeholder="$t('merchandise', 'pleaseEnterSpecificAmount')"
          ></el-input>
        </el-radio>
        <el-radio v-model="radio" label="2">
          {{ $t('merchandise', 'rangeAmount') }}
          <el-input
            style="width: 100px"
            type="number"
            :disabled="radio !== '2'"
            v-model="ruleForm.areaPrice[0]"
            :placeholder="$t('merchandise', 'pleaseEnterRangeAmount')"
          ></el-input>
          ~
          <el-input
            style="width: 100px"
            type="number"
            :disabled="radio !== '2'"
            v-model="ruleForm.areaPrice[1]"
            :placeholder="$t('merchandise', 'pleaseEnterRangeAmount')"
          ></el-input>
        </el-radio>
      </el-form-item>
      <el-form-item :label="$t('merchandise', 'productDescription')" prop="describe">
        <el-input
          style="width: 330px"
          v-model="ruleForm.describe"
          :placeholder="$t('merchandise', 'pleaseEnterContent')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('merchandise', 'goodsImage')" prop="productsPhoto">
        <p style="color: rgb(150, 150, 150)">
          {{ $t('merchandise', 'uploadImageTip') }}
        </p>
        <el-upload
          :action="uploadUrl"
          :class="{ disabled: uploadDisabled }"
          list-type="picture-card"
          :on-progress="handProgress"
          :on-success="handleSuccess"
          :on-remove="handleRemove"
          :limit="5"
          :file-list="ruleForm.productsPhoto"
        >
          <i class="el-icon-plus"></i>
        </el-upload>
      </el-form-item>
      <el-form-item :label="$t('merchandise', 'shareImage')" prop="sharePhoto">
        <p style="color: rgb(150, 150, 150)">
          {{ $t('merchandise', 'shareImageTip') }}
        </p>
        <el-upload
          :action="uploadUrl"
          list-type="picture-card"
          :class="{ disabled: uploadShareDisabled }"
          :file-list="ruleForm.sharePhoto"
          :on-progress="handProgress"
          :on-success="handleSuccess2"
          :on-remove="handleRemove2"
          :limit="1"
        >
          <i class="el-icon-plus"></i>
          <div style="color: #bcc3d3" class="el-upload__tip" slot="tip">
            {{ $t('merchandise', 'forMiniProgramShare') }}
          </div>
        </el-upload>
      </el-form-item>
      <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'serviceMethod') }}</p>
      <el-form-item :label="$t('merchandise', 'serviceType')" prop="serviceType">
        <el-checkbox-group v-model="ruleForm.serviceType">
          <el-checkbox label="1">{{ $t('merchandise', 'inStore') }}</el-checkbox>
          <el-checkbox label="2">{{ $t('merchandise', 'homeService') }}</el-checkbox>
        </el-checkbox-group>
      </el-form-item>
      <p class="cA2 fwbold fs8 mb20">{{ $t('merchandise', 'inputProductDetails') }}</p>
      <quill-editor
        style="height: 100%"
        v-model="ruleForm.productsDetails"
        ref="myQuillEditor"
        :options="editorOption"
      />
    </el-form>
    <el-button class="mt10" type="primary" @click="addGoodsInfo"
      >{{ $t('merchandise', 'publish') }}</el-button
    >
  </div>
</template>

<script>
import {
  getProductsInfo,
  selectProductsTypeList,
  insertProducts,
} from "@/api/management";
import {
  addAppointmentGoodsType,
} from "@/api/companyManage.js";
import { quillEditor, Quill } from "vue-quill-editor"; //
import resizeImage from "quill-image-resize-module"; // 调整大小组件。
import { ImageDrop } from "quill-image-drop-module"; // 拖动加载图片组件
import quillConfig from "@/utils/quill-config.js";
import i18nMixin from '@/mixins/i18nMixin';
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/resizeImage ", resizeImage);
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
quillConfig.placeholder = '请填写商品内容'

export default {
  mixins: [i18nMixin],
  data() {
    var validatePass2 = (rule, value, callback) => {
      if (this.radio === "1" && this.ruleForm.specificPrice == "") {
        console.log(2222)
        callback(new Error(this.$t('merchandise', 'pleaseEnterSpecificPrice')));
      } else if (
        this.radio === "2" &&
        this.ruleForm.areaPrice[0] == "" &&
        this.ruleForm.areaPrice[1] == ""
      ) {
        callback(new Error(this.$t('merchandise', 'pleaseEnterRangePrice')));
      } else {
        callback();
      }
    };
    return {
      uploadUrl:this.$store.state.uploadingUrl,
      ossUrl:this.$store.state.ossUrl,
      editorOption: quillConfig,
      radio: "1",
      ruleForm: {
        productsTypeId: "",
        productsName: "",
        specificPrice: "",
        areaPrice: ["", ""],
        describe: "",
        serviceType: [],
        productsPhoto: [],
        sharePhoto: [],
        productsDetails: "",
      },
      Details:'',
      rules: {
        productsTypeId: [{ required: true, message: this.$t('merchandise', 'pleaseSelectCategory') }],
        productsName: [
          {
            required: true,
            message: this.$t('merchandise', 'pleaseEnterProductTitle'),
            trigger: "change",
          },
        ],
        specificPrice: [{ validator: validatePass2 }],
        describe: [
          { required: true, message: this.$t('merchandise', 'pleaseEnterDescription'), trigger: "change" },
        ],
        productsPhoto: [{ required: true, message: this.$t('merchandise', 'pleaseUploadProductImage') }],
        sharePhoto: [{ required: true, message: this.$t('merchandise', 'pleaseUploadShareImage') }],
        serviceType: [{ required: true, message: this.$t('merchandise', 'pleaseSelectServiceType') }],
      },
      options: [],
    };
  },
  components: {
    quillEditor,
  },
  computed: {
    uploadDisabled(){
      return this.ruleForm.productsPhoto.length >=  5;
    },
    uploadShareDisabled(){
      return this.ruleForm.sharePhoto.length !==  0;
    }
  },
  async created() {
    this.selectProductsTypeList();
    if (this.$route.query.id) {
      this.getProductsInfo();
    }
    
    // 监听语言变化，强制更新组件
    this.$root.$on('language-changed', () => {
      this.$forceUpdate();
    });
  },
  beforeDestroy() {
    // 清理事件监听
    this.$root.$off('language-changed');
  },
  methods: {
    handProgress(event, file, fileList) {
      this.$message({
        message: this.$t('merchandise', 'uploadingImage'),
      });
    },
    handleRemove(file, fileList) {
      
    },
    handleRemove2(file, fileList){
      this.ruleForm.sharePhoto = fileList
    },
    handleSuccess(response, file, fileList) {
      this.$message.closeAll();
      this.$message({
        message: this.$t('merchandise', 'uploadSuccess'),
        type: "success",
      });
      let arr = [];
      fileList = fileList.map((item) => {
        if (item.response) {
          arr.push({
            url: `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${item.response.data}`,
            uid: item.uid,
          });
        } else {
          arr.push(item);
        }
      });
      this.ruleForm.productsPhoto = arr;
    },
    handleSuccess2(response, file, fileList) {
      this.$message.closeAll();
      this.$message({
        message: this.$t('merchandise', 'uploadSuccess'),
        type: "success",
      });
      let arr = [];
      fileList = fileList.map((item) => {
        if (item.response) {
          arr.push({
            url: `https://one-stand-domo.oss-cn-shenzhen.aliyuncs.com/${item.response.data}`,
            uid: item.uid,
          });
        } else {
          arr.push(item);
        }
      });
      this.ruleForm.sharePhoto = arr;
      console.log(this.ruleForm.sharePhoto)
    },
    async getProductsInfo() {
      const result = await getProductsInfo(
        { productsId: this.$route.query.id },
        { showLoading: true }
      );
      const {
        productsTypeId,
        productsName,
        describe,
        productsPhoto,
        sharePhoto,
        serviceType,
        productsDetails,
      } = result.data;
      this.ruleForm.productsTypeId = productsTypeId;
      this.ruleForm.productsName = productsName;
      if (productsPhoto.split(",") && productsPhoto.split(",").length !== 0) {
        let arr = [];
        productsPhoto.split(",").map((item, index) => {
          arr.push({ url: item, uid: index });
        });
        this.ruleForm.productsPhoto = arr;
      }
      this.ruleForm.describe = describe;
      this.ruleForm.sharePhoto = [{ url: sharePhoto, uid: 1 }];
      this.ruleForm.productsDetails = productsDetails;
      this.ruleForm.serviceType =
        serviceType == 3 ? ["1", "2"] : [String(serviceType)];
      let price;
      try {
        price = JSON.parse(result.data.price);
      } catch (e) {
        price = parseInt(result.data.price) || 0;
      }
      if (
        Object.prototype.toString.call(price).toLowerCase() ===
        "[object number]"
      ) {
        this.radio = "1";
        this.ruleForm.specificPrice = result.data.price;
      } else {
        this.radio = "2";
        this.ruleForm.areaPrice = price;
      }
    },
    async selectProductsTypeList() {
      const result = await selectProductsTypeList({ ignore: true });
      this.options = result.data;
    },
    addGoodsInfo() {
      if(this.ruleForm.productsPhoto.length == 0){
        return this.$message({
          message: this.$t('merchandise', 'productImageNotUploaded'),
          type: "warning",
          center: true,
        });
      }
      if(this.ruleForm.sharePhoto.length == 0){
        return this.$message({
          message: this.$t('merchandise', 'productShareImageNotUploaded'),
          type: "warning",
          center: true,
        });
      }
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          console.log(this.ruleForm.sharePhoto)
          let data = {
            ...this.ruleForm,
            price:
              this.radio == 1
                ? this.ruleForm.specificPrice
                : JSON.stringify(this.ruleForm.areaPrice),
            serviceType: this.ruleForm.serviceType.reduce(
              (sum, val) => parseInt(sum) + parseInt(val)
            ),
            productsPhoto: this.ruleForm.productsPhoto
              .map((item) => item.url.replace(".primary.png", ""))
              .join(","),
            sharePhoto: this.ruleForm.sharePhoto[0].url ||  '',
          };
          if (this.$route.query.id) data.productsId = this.$route.query.id;
          let result = await insertProducts(data, { showLoading: true });
          if(result.code == 201){
            this.$message({
              message:result.message,
              type: "warning",
              center: true,
            });
          }else{
            setTimeout(() => {
              this.$router.go(-1);
            }, 1000);
          }
          
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //新增
    addGoodsType(){
      this.$prompt(this.$t('merchandise', 'addNewCategory'), this.$t('common', 'info'), {
        confirmButtonText: this.$t('common', 'confirm'),
        cancelButtonText: this.$t('common', 'cancel'),
      })
      .then(({ value }) => {
        let data = {
          productsTypeName: value,
        };
        addAppointmentGoodsType(data)
        .then(res=>{
          this.$message({
            type: "success",
            message: res.message,
          });
          this.searchKey = ''
          this.selectProductsTypeList();
        });

      })
      .catch((err) => {
        console.log(err);
        this.$message({
          type: "info",
          message: this.$t('merchandise', 'cancelInput'),
        });
      });
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ input::-webkit-outer-spin-button,
/deep/ input::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
/deep/ input[type="number"] {
  -moz-appearance: textfield !important;
}
/deep/ .disabled .el-upload--picture-card {
    display: none;
}
</style>